// ReportHeaderProjectGraph component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import * as d3 from 'd3'
import _ from 'lodash'
import $ from 'jquery'

import currency from '../../../lib/currency.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'

class ReportHeaderProjectGraph extends Component {
  static get propTypes () {
    return {
      data: PropTypes.object,
      contentPadding: PropTypes.number
    }
  }

  static get defaultProps () {
    return {
      data: null,
      contentPadding: 100
    }
  }

  constructor (props) {
    super(props)

    this.data = {
      oldData: null,
      newData: props.data
    }

    this._resizeHandler = this._resize.bind(this)
    this._references = {
      refGraphWrap: React.createRef(),
      graphstat: React.createRef()
    }
  }

  componentDidMount () {
    $(window).on('resize', this._resizeHandler)
    this._renderChart()
  }

  componentWillUnmount () {
    $(window).off('resize', this._resizeHandler)
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (_.isEqual(this.props.data, nextProps.data)) {
      this.data.oldData = this.props.data
      this.data.newData = nextProps.data
      this._renderChart()
    } else {
      this.data.oldData = null
    }
  }

  render () {
    return (
      <div className='graphstat' ref={this._references.refGraphWrap}>
        <svg width={750} height='250' ref={this._references.graphstat} />
      </div>
    )
  }

  _resize () {
    window.setTimeout(this._updateSvg.bind(this), 100)
  }

  _updateSvg () {
    this._renderChart()
  }

  _renderChart () {
    if (
      !this._references.refGraphWrap.current ||
      !this._references.graphstat.current
    ) {
      return null
    }

    const graphWrapRef = ReactDOM.findDOMNode(
      this._references.refGraphWrap.current
    ).getBoundingClientRect()
    const graphWrapWidth = graphWrapRef.width

    const svg = d3.select(this._references.graphstat.current)
    svg.html('')
    svg.attr('width', graphWrapWidth)
    const margin = { top: 40, right: 0, bottom: 30, left: 14 }
    const width = +svg.attr('width') - margin.left - margin.right
    const height = +svg.attr('height') - margin.top - margin.bottom

    const x = d3.scaleLinear().range([0, width])
    const y = d3.scaleBand().range([height, 0])

    let bar = ''
    let labelWidth = 0
    const barHeight = 22
    const barPadding = 18

    const data = []
    const columns = [
      'totalInvoiced',
      'totalBudget',
      'totalPlanned',
      'totalTracked'
    ]
    columns.map(colIdent => {
      data.push({ label: colIdent, value: this.data.newData[colIdent] })
    })

    const max = d3.max(data, function (d) {
      return d.value
    })
    x.domain([
      0,
      d3.max(data, d => {
        return d.value
      })
    ])
    y.domain(
      data.map(d => {
        return d.label
      })
    ).padding(0.1)

    bar = svg
      .selectAll('g')
      .data(data)
      .enter()
      .append('g')

    bar
      .attr('class', 'bar')
      .attr('cx', 0)
      .attr('transform', function (d, i) {
        return (
          'translate(' +
          12 +
          ',' +
          (i * (barHeight + barPadding) + barPadding) +
          ')'
        )
      })

    bar
      .append('rect')
      .attr('class', 'bar')
      .attr('y', barHeight / 2)
      .attr('dy', '.35em') // vertical align middle
      .attr('height', 5)
      .attr('width', d => {
        return x(d.value)
      })
      .attr('fill', '#4dbce7')
      .attr('transform', 'translate(' + labelWidth + ', 0)')

    bar
      .append('text')
      .attr('class', 'label')
      .attr('y', 0)
      .attr('dy', '.01em') // vertical align middle
      .attr('fill', '#fff')
      .text(function (d) {
        const ident = `report.header.${d.label}Title`
        const info = IntlUtil.convertMessage(ident)
        return d.value > 0 ? info : ''
      })
      .each(function () {
        labelWidth = Math.ceil(Math.max(labelWidth, this.getBBox().width))
      })

    d3.scaleLinear()
      .domain([0, max])
      .range([0, width - 40 * 2 - labelWidth])

    bar
      .append('text')
      .attr('class', 'value')
      .attr('y', d => {
        const xVal = x(d.value)
        return xVal > graphWrapWidth / 2 ? 0 : barHeight / 2 + 1
      })
      .attr('dx', d => {
        const xVal = x(d.value)
        const dxVal = xVal > graphWrapWidth / 2 ? 0 : labelWidth + 20
        return xVal < 120 ? 120 : dxVal
      })
      .attr('dy', '.45em') // vertical align middle
      .attr('text-anchor', 'end')
      .text(function (d) {
        return d.value ? currency.formatSymbol(d.value) : ''
      })
      .attr('x', d => {
        const xVal = x(d.value)
        return xVal
      })
      .attr('fill', '#fff')

    svg
      .append('g')
      .attr('class', 'x axis')
      .attr('transform', `translate(12, ${height})`)
      .call(
        d3
          .axisBottom(x)
          .tickSize(0)
          .tickPadding(6)
          .tickFormat(this._formatXAxis.bind(this))
          .tickSizeInner([-height])
      )
  }

  _formatXAxis (d) {
    return `${currency.format(d)}`
  }
}

export default ReportHeaderProjectGraph
